import { BasicInfo } from "@/types";
import { atom } from "jotai";

const basicInfoAtom = atom<BasicInfo | null>(null)

export default basicInfoAtom
